export const PHONE_DISPLAY = "+41 79 177 24 24";
export const PHONE_TEL = "+41791772424";
export const WHATSAPP_URL = "https://wa.me/41791772424";
export const EMAIL = "Info@airporttransfer24.ch";
export const ADDRESS_LINE1 = "Flughafenstrasse 1";
export const ADDRESS_LINE2 = "8302 Kloten";
export const MAPS_URL = "https://www.google.com/maps/search/?api=1&query=Flughafenstrasse+1+8302+Kloten";
